import jQuery from 'jquery';

// import して使うのが理想だが、グローバルなjQueryを参照するコードが沢山あるので
// jQuery や $ をグローバル変数として定義しておく。
window.jQuery = jQuery;
window.$ = jQuery;
